import { animate, state, style, transition, trigger } from '@angular/animations';
import { KeyValuePipe, NgClass } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, HostBinding, inject, Input } from '@angular/core';
import { ValidationErrors } from '@angular/forms';
import { MatError } from '@angular/material/form-field';
import { TranslateModule } from '@ngx-translate/core';

import { ParseErrorPipe } from './parse-error.pipe';

@Component({
  selector: 'rms-control-error',
  imports: [KeyValuePipe, ParseErrorPipe, TranslateModule, MatError, NgClass],
  template: `
    @for (error of (errors | keyvalue)?.slice(0, 1); track error.key) {
      <mat-error [ngClass]="{ hidden: !errorState }">{{ error | parseError: label }} </mat-error>
    }
  `,
  animations: [
    trigger('showIn', [
      state('in', style({ top: '0', opacity: '1' })),
      state('out', style({ top: '-15px', opacity: '0' })),
      transition('out => in', [animate('250ms ease')]),
    ]),
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  styles: `
    :host {
      @apply relative;
    }
  `,
})
export class ControlErrorComponent {
  @Input() public label = '';

  @Input() public errors?: ValidationErrors | null;

  @Input() public errorState!: boolean;

  public readonly cdr = inject(ChangeDetectorRef);

  @HostBinding('@showIn')
  public get showIn(): string {
    return this.errorState ? 'in' : 'out';
  }
}
